const BundleInstantSaving = ({ bundles, setBundleInView, t, bundleInView }) => {
  return (
    <div className="bg-[#F7F5F5] h-full border rounded-md">
      <h4 className="p-4 max-sm:text-sm text-xl font-bold">{t("Instant Saving")}</h4>
      <ul className="flex flex-col gap-3">
        {bundles?.map((bundle, i) => (
          <li
            onClick={() => setBundleInView(bundle)}
            key={i}
            className={`px-4 py-1.5 cursor-pointer max-sm:text-sm hover:bg-white ${
              bundle?.title === bundleInView?.title ? "bg-white" : null
            }`}
          >
            {bundle?.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BundleInstantSaving;
